// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//  引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Axios from 'axios';
import qs from 'qs';
//引入图片查看大图插件
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
Vue.use(preview);
Vue.prototype.$http = Axios;
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.use(ElementUI);

// 防重复点击
import noclickfrom from './utils/noclick.js'
Vue.prototype.$noMultipleClicks = noclickfrom.noMultipleClicks;

// Vue.prototype.baseURL = '/api';//接口(本地)
Vue.prototype.baseURL = '/api/www'; //官网代 理接口(本地)
Vue.prototype.$qs = qs; //格式化数据
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',

})


// WEBPACK FOOTER //
// ./src/main.js